import { CaretDownOutlined } from '@ant-design/icons';
import { Collapse, CollapseProps } from 'antd';
import React from 'react';
import styles from './withCollapsible.module.scss';

const WithCollapsible = <T extends {}>(WrappedComponent: React.ComponentType<T>, headerText) => {
	const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

	const ComponentWithLoader: React.ComponentType<T> = props => {
		const items: CollapseProps['items'] = [
			{
				key: '1',
				label: <span className={styles.headerFontColor}>{headerText}</span>,
				children: <WrappedComponent {...(props as T)} />,
				className: styles.item,
			},
		];

		const handleOnExpandIcon = ({ isActive }) => <CaretDownOutlined rotate={isActive ? 180 : 0} className={styles.expandIcon} />;

		return (
			<Collapse
				size='small'
				bordered={true}
				defaultActiveKey={['1']}
				items={items}
				expandIconPosition='end'
				expandIcon={handleOnExpandIcon}
				className={styles.collapse}
			/>
		);
	};

	ComponentWithLoader.displayName = `withCollapsible(${displayName})`;

	return ComponentWithLoader;
};

export { WithCollapsible };
